import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confidentiality-acknowledgement',
  templateUrl: './confidentiality-acknowledgement.component.html',
  styleUrls: ['./confidentiality-acknowledgement.component.css']
})
export class ConfidentialityAcknowledgementComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ConfidentialityAcknowledgementComponent>) { }

  ngOnInit(): void {
  }

  onOK(): void {
    this.dialogRef.close(true);
  }

}
